/* eslint-disable no-unused-vars */
import React, { useMemo, useState } from 'react';

import Button from '@/components/Button';
import { WizardStep } from '@/components/Wizard';
import { appUiIds } from '@/constants/appUiIds';
import { Session } from '@/helpers/signinUtils';

import useAppUiData from '@/hooks/useAppUiData';

import styles from './ClaimBookingStep.module.scss';

import ClaimBookingRadioGroup from './controls/ClaimBookingRadioGroup';
import { MatchingClient, StepData } from '../types/ClaimBookingTypes';

const CURRENT_USER_ID = 'current';

type Sailor = {
  clientId: string;
  [key: string]: any;
};

type ClaimBookingEmailSelectProps = {
  tabId: string;
  data: StepData;
  currentUser: Session | undefined;
  onSubmit: Function;
  onCancel: () => void;
};

const ClaimBookingEmailSelect: React.FC<ClaimBookingEmailSelectProps> = ({
  tabId,
  data,
  currentUser,
  onSubmit,
  onCancel,
}) => {
  const appUiData = useAppUiData();
  const [matchedSailor] = data.sailors || [];
  const sailors = useMemo(
    () => [{ clientId: CURRENT_USER_ID, email: currentUser?.email }, matchedSailor],
    [currentUser, matchedSailor],
  );

  const [selectedSailor, setSelectedSailor] = useState(sailors?.[0]);

  const handleChange = (value: MatchingClient) => {
    setSelectedSailor(value);
  };

  const handleSubmit = () => {
    const value = {
      bookingNumber: data.bookingNumber,
      sailors: [matchedSailor],
      updateProfileEmail: selectedSailor.clientId !== CURRENT_USER_ID,
      isManualEntry: false,
    };
    onSubmit(value);
  };

  return (
    <WizardStep tabId={tabId}>
      <h2 className={styles.title}>{appUiData[appUiIds.claimBooking.selectEmailTitle]}</h2>
      <p className={styles.subtitle}>{appUiData[appUiIds.claimBooking.selectEmailSubtitle]}</p>
      <form className={styles.selectForm}>
        <div className={styles.radioGroup}>
          <ClaimBookingRadioGroup
            sailors={sailors}
            selectedSailor={selectedSailor}
            onChange={handleChange}
            labelFunction={(sailor) => sailor.email}
          />
        </div>
        <Button variant="primary" onClick={handleSubmit} disabled={false} className={styles.buttonNext}>
          {appUiData[appUiIds.claimBooking.next]}
        </Button>
        <Button onClick={onCancel} className={styles.cancelLink}>
          {appUiData[appUiIds.commonLabels.cancel]}
        </Button>
      </form>
    </WizardStep>
  );
};

export default ClaimBookingEmailSelect;
